export const API_BASE_URL = process.env.API_URL || 'https://api.connectapp.me';
export const JWT_STORAGE_KEY = 'JWT_STORAGE_KEY';

export const USER_STATUSES = {
  ACTIVE: "active",
  BLOCKED: "blocked",
  DELETED: "deleted",
};

export const VERIFICATION_STATUSES = {
  VERIFIED: "verified",
  NOT_VERIFIED: "not_verified",
};

export const COMPLAINT_STATUSES = {
  NEW: "new",
  IN_PROGRESS: "in_progress",
  RESOLVED: "resolved",
};
